import React from 'react';
import { Heart, Activity, Zap } from 'lucide-react';
import SEO from '../components/SEO';
import SpecialtyPageTemplate from '../components/SpecialtyPageTemplate';

const CardiologyPage = () => {
  const config = {
    badge: "Cardiac Speciality",
    headline: "Precision",
    headlineItalic: "Heart Healing.",
    subtext: "Dedicated to the rhythm of life — advanced cardiac diagnostics and therapeutic excellence for your pet's vital health.",
    image: "/images/services/cardiology.png",
    imageAlt: "Cardiology at Dr. Suresh Pet Care — Advanced 2D Echo or ECG equipment",
    stats: [
      { value: 1200, suffix: '+', label: 'Cardiac Cases' },
      { value: 98, suffix: '%', label: 'Diagnostic Accuracy' },
      { value: 12, suffix: '+ Yrs', label: 'Expertise' },
      { value: 24, suffix: '/7', label: 'Emergency Care' },
    ],
    services: [
      {
        title: "2D Echo & Ultrasound",
        icon: <Activity size={28} />,
        desc: "Comprehensive echocardiography to visualize heart structure and valve function in real time.",
        specs: ["Cardiac Ultrasound", "Valve Assessment", "Blood Flow Mapping", "Congenital Screening"],
        color: "from-blue-500/10 to-primary/10"
      },
      {
        title: "ECG Monitoring",
        icon: <Zap size={28} />,
        desc: "High-precision electrocardiography to detect arrhythmias and complex conduction disorders.",
        specs: ["Arrhythmia Detection", "Heart Rate Analysis", "Conduction Audit", "Pre-Surgical Screening"],
        color: "from-primary/10 to-emerald-500/10"
      },
      {
        title: "Heart Failure Management",
        icon: <Heart size={28} />,
        desc: "Advanced therapeutic protocols for congestive heart failure and chronic cardiac conditions.",
        specs: ["Diuretic Therapy", "Inotropic Support", "Dietary Regulation", "Long-term Monitoring"],
        color: "from-rose-500/10 to-primary/10"
      }
    ],
    sectionTitle: "Our Cardiac",
    sectionItalic: "Capabilities.",
    warningTitle: "Common Cardiac",
    warningItalic: "Symptoms.",
    warningText: "Recognizing early warning signs is critical for effective heart health management. Early detection dramatically improves treatment outcomes.",
    warnings: [
      { name: "Persistent Coughing", desc: "Especially at night or after exercise — often a first sign of cardiac dysfunction.", icon: "🫁" },
      { name: "Exercise Intolerance", desc: "Getting winded easily on short walks — indicates reduced cardiac output.", icon: "🐾" },
      { name: "Fainting Spells", desc: "Sudden collapse or loss of consciousness — requires urgent cardiac evaluation.", icon: "⚡" },
      { name: "Labored Breathing", desc: "Increased effort to breathe even at rest — may indicate fluid in the lungs.", icon: "💨" }
    ],
    ctaBadge: "Cardiac Unit",
    ctaTitle: "The Cardiology",
    ctaItalic: "Expertise.",
    ctaText: "Led by Dr. T Suresh Babu, our cardiology unit integrates modern imaging with clinical precision to manage complex heart health challenges.",
    ctaBtn: "Schedule Echo Scan",
    seoText: "Leading veterinary cardiology in Hyderabad. 2D Echo and ECG for dogs and cats. Expert heart health management at Dr. Suresh Pet Care Hospital.",
    glowColor: "rose-500"
  };

  return (
    <>
      <SEO 
        title="Advanced Veterinary Cardiology | Heart Health for Pets"
        description="Expert cardiac care and heart health monitoring for pets at Dr. Suresh Pet Care. State-of-the-art 2D Echo, ECG, and heart failure management in Hyderabad."
        canonical="/cardiology"
      />
      <SpecialtyPageTemplate config={config} />
    </>
  );
};


export default CardiologyPage;
